import React from 'react';
import { downloadBase64Data } from 'utils/fileHelper';

interface IAffiliatesDocuments {
  setUploadMode: any;
  affiliate: any;
  deleteDoc: any;
}

const AffiliatesDocuments: React.FC<IAffiliatesDocuments> = ({ setUploadMode, affiliate, deleteDoc }) => {
  const convertTimestamp = (time: any) => {
    let date: any = new Date(time);
    date = date.toLocaleDateString();
    return date;
  };

  return (
    <div className='affiliate-documents-container'>
      <div className='affiliate-documents-table'>
        <div className='affiliates-pending-header'>
          <div className='affiliates-pending-header-group'>
            <div className='affiliates-pending-header-group-text'>
              <div className='affiliates-pending-header-group-frame'>
                <div className='affiliates-pending-header-group-inner'>
                  <div className='affiliates-pending-header-group-primary'>
                    Shared Documents/Templates
                  </div>
                  <div className='affiliate-document-upload-btn' onClick={() => setUploadMode(true)}>
                    + Upload
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='affiliate-documents-head-columns'>
          <div className='affiliate-documents-file-column'>
            <div className='affiliate-documents-column-inner'>
              <div className='affiliate-documents-column-text'>
                File Name
              </div>
            </div>
          </div>
          <div className='affiliate-documents-date-column'>
            <div className='affiliate-documents-column-inner'>
              <div className='affiliate-documents-column-text'>
                Date Uploaded
              </div>
            </div>
          </div>
          <div className='affiliate-documents-placeholder-column'></div>
        </div>
        {!affiliate.isLoading && affiliate.data.documents.length === 0 && (
          <div className='affiliate-documents-row'>
            <div className='affiliate-documents-row-content'></div>
          </div>
        )}
        {!affiliate.isLoading && affiliate?.data?.documents?.map((doc: any, index: number) => (
          <div key={index} className='affiliate-documents-row'>
            <div className='affiliate-documents-row-content'>
              <div className='affiliate-documents-row-frame'>
                <div className='affiliate-documents-row-name-cell'>
                  <div className='affiliate-documents-row-name-cell-icon'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='28' height='30' viewBox='0 0 28 30' fill='none'>
                      <path d='M4.75 4C4.75 2.20507 6.20507 0.75 8 0.75H19C19.0412 0.75 19.0807 0.766365 19.1098 0.795496L27.2045 8.89016C27.2336 8.9193 27.25 8.9588 27.25 9V26C27.25 27.7949 25.7949 29.25 24 29.25H8C6.20508 29.25 4.75 27.7949 4.75 26V4Z' stroke='#2E3036' strokeWidth='1.5'/>
                      <path d='M19 0.375V5C19 7.20914 20.7909 9 23 9H27.625' stroke='#2E3036' strokeWidth='1.5'/>
                      <path d='M0 16C0 14.8954 0.895431 14 2 14H17C18.1046 14 19 14.8954 19 16V24C19 25.1046 18.1046 26 17 26H2C0.895431 26 0 25.1046 0 24V16Z' fill='#079455'/>
                      <path d='M4.43182 17.6364L5.31179 19.1236H5.34588L6.23011 17.6364H7.27202L5.94034 19.8182L7.30185 22H6.24077L5.34588 20.5107H5.31179L4.4169 22H3.36009L4.72585 19.8182L3.38565 17.6364H4.43182ZM7.85582 22V17.6364H8.77841V21.2393H10.6491V22H7.85582ZM13.6273 18.8913C13.6103 18.7195 13.5371 18.5859 13.4078 18.4908C13.2786 18.3956 13.1032 18.348 12.8816 18.348C12.731 18.348 12.6039 18.3693 12.5002 18.4119C12.3965 18.4531 12.3169 18.5107 12.2615 18.5845C12.2076 18.6584 12.1806 18.7422 12.1806 18.8359C12.1777 18.9141 12.1941 18.9822 12.2296 19.0405C12.2665 19.0987 12.3169 19.1491 12.3809 19.1918C12.4448 19.233 12.5186 19.2692 12.6025 19.3004C12.6863 19.3303 12.7757 19.3558 12.8709 19.3771L13.263 19.4709C13.4533 19.5135 13.628 19.5703 13.7871 19.6413C13.9462 19.7124 14.084 19.7997 14.2005 19.9034C14.3169 20.0071 14.4071 20.1293 14.4711 20.2699C14.5364 20.4105 14.5698 20.5717 14.5712 20.7536C14.5698 21.0206 14.5016 21.2521 14.3667 21.4482C14.2331 21.6428 14.04 21.794 13.7871 21.902C13.5357 22.0085 13.2324 22.0618 12.8773 22.0618C12.525 22.0618 12.2182 22.0078 11.9569 21.8999C11.6969 21.7919 11.4938 21.6321 11.3475 21.4205C11.2026 21.2074 11.1266 20.9439 11.1195 20.63H12.0123C12.0222 20.7763 12.0641 20.8984 12.138 20.9964C12.2132 21.093 12.3134 21.1662 12.4384 21.2159C12.5648 21.2642 12.7076 21.2884 12.8667 21.2884C13.0229 21.2884 13.1586 21.2656 13.2736 21.2202C13.3901 21.1747 13.4803 21.1115 13.5442 21.0305C13.6081 20.9496 13.6401 20.8565 13.6401 20.7514C13.6401 20.6534 13.611 20.571 13.5527 20.5043C13.4959 20.4375 13.4121 20.3807 13.3013 20.3338C13.1919 20.2869 13.0577 20.2443 12.8986 20.206L12.4235 20.0866C12.0556 19.9972 11.7651 19.8572 11.552 19.6669C11.339 19.4766 11.2331 19.2202 11.2346 18.8977C11.2331 18.6335 11.3034 18.4027 11.4455 18.2053C11.589 18.0078 11.7857 17.8537 12.0357 17.7429C12.2857 17.6321 12.5698 17.5767 12.888 17.5767C13.2118 17.5767 13.4945 17.6321 13.736 17.7429C13.9789 17.8537 14.1678 18.0078 14.3027 18.2053C14.4377 18.4027 14.5073 18.6314 14.5115 18.8913H13.6273Z' fill='#EFF1F6'/>
                    </svg>
                  </div>
                  <div className='affiliate-documents-row-name-cell-group'>
                    <div className='affiliate-documents-row-name-cell-text'>
                      {doc.uploadedFile.name}
                    </div>
                  </div>
                </div>
                <div className='affiliate-documents-row-date-cell'>
                  <div className='affiliate-documents-row-date-cell-inner'>
                    <div className='affiliate-documents-row-date-cell-text'>
                      {convertTimestamp(doc.uploadedFile.dateAdded)}
                    </div>
                  </div>
                </div>
                <div className='affiliate-documents-row-placeholder-cell'>
                  <svg onClick={() => deleteDoc(doc, index)} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                    <path d='M6.75 2.25H11.25M2.25 4.5H15.75M14.25 4.5L13.724 12.3895C13.6451 13.5732 13.6057 14.165 13.35 14.6138C13.1249 15.0088 12.7854 15.3265 12.3762 15.5248C11.9115 15.75 11.3183 15.75 10.132 15.75H7.86799C6.68168 15.75 6.08852 15.75 5.62375 15.5248C5.21457 15.3265 4.87507 15.0088 4.64999 14.6138C4.39433 14.165 4.35488 13.5732 4.27596 12.3895L3.75 4.5M7.5 7.875V11.625M10.5 7.875V11.625' stroke='#BDBEC1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                  <svg onClick={() => downloadBase64Data(doc.uploadedFile.base64, doc.uploadedFile.name)} style={{ cursor: 'pointer' }} xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18' fill='none'>
                    <path d='M6 12.75L9 15.75M9 15.75L12 12.75M9 15.75V9M15 12.5571C15.9161 11.8005 16.5 10.656 16.5 9.375C16.5 7.09683 14.6532 5.25 12.375 5.25C12.2111 5.25 12.0578 5.1645 11.9746 5.0233C10.9965 3.36363 9.19082 2.25 7.125 2.25C4.0184 2.25 1.5 4.7684 1.5 7.875C1.5 9.42458 2.12659 10.8278 3.14021 11.8451' stroke='#BDBEC1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AffiliatesDocuments;
